module.exports = __webpack_public_path__ + "static/media/theTrapJ.ac2427d1.svg";